import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=449cd30a&scoped=true&"
import script from "./ContentWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449cd30a",
  null
  
)

export default component.exports